import axiosClient from './axiosClient';
import { PermissionModel } from '../Models/permissionModel';

const permissionService = {
  getAll: () => {
    return axiosClient.get('/Permission')
      .catch((err) => {
        if (err?.response?.status === 404) {
          console.warn("GET /Permission returned 404. Falling back to GET /permissions...");
          return axiosClient.get('/permissions');
        }
        return Promise.reject(err);
      })
      .then((res) => {
        const rawList = res?.data?.data || res?.data || [];
        const mappedList = (Array.isArray(rawList) ? rawList : []).map(PermissionModel.toFrontend);
        return {
          data: mappedList,
        };
      });
  },

  getById: (permissionID) => {
    return axiosClient.get(`/Permission/${permissionID}`)
      .catch((err) => {
        if (err?.response?.status === 404) {
          console.warn(`GET /Permission/${permissionID} returned 404. Falling back to GET /permissions/${permissionID}...`);
          return axiosClient.get(`/permissions/${permissionID}`);
        }
        return Promise.reject(err);
      })
      .then((res) => {
        const raw = res?.data?.data || res?.data;
        return {
          data: PermissionModel.toFrontend(raw),
        };
      });
  },

  create: (payload) => {
    const body = PermissionModel.toBackend(payload);
    body.permissionId = 0;

    return axiosClient.post('/Permission', body)
      .catch((err) => {
        if (err?.response?.status === 404) {
          console.warn("POST /Permission returned 404. Falling back to POST /permissions...");
          return axiosClient.post('/permissions', body);
        }
        return Promise.reject(err);
      })
      .then((res) => {
        const raw = res?.data?.data || res?.data;
        return {
          data: PermissionModel.toFrontend(raw),
        };
      });
  },

  update: (permissionID, payload) => {
    const body = PermissionModel.toBackend({ ...payload, permissionID });

    return axiosClient.put('/Permission', body)
      .catch((err) => {
        if (err?.response?.status === 404) {
          console.warn("PUT /Permission returned 404. Falling back to PUT /permissions...");
          return axiosClient.put('/permissions', body);
        }
        return Promise.reject(err);
      })
      .then((res) => {
        const raw = res?.data?.data || res?.data;
        return {
          data: PermissionModel.toFrontend(raw),
        };
      });
  },

  remove: (permissionID) => {
    return axiosClient.delete(`/Permission/${permissionID}`)
      .catch((err) => {
        if (err?.response?.status === 404) {
          console.warn(`DELETE /Permission/${permissionID} returned 404. Falling back to DELETE /permissions/${permissionID}...`);
          return axiosClient.delete(`/permissions/${permissionID}`);
        }
        return Promise.reject(err);
      });
  },
};

export default permissionService;
